import React, { Component } from "react";
import FormComponent from "../../Form/FormComponent";
import { addUser } from "./UserConfig";
import { TextField, Button, Chip, FormHelperText } from "@material-ui/core";
import { saveUserdata, getAllSites } from "./UserQueries";
import { mutationQueries } from "../../MutationMethod";
import { FadeLoader } from "react-spinners";
import SnackBarComponent from "../../SnackBar/SnackBar";
import gql from "graphql-tag";
import { fetchMethod, debounce } from "../../FetchMethod";
import Autocomplete from "@material-ui/lab/Autocomplete";
import AddIcon from "@material-ui/icons/Add";
import SearchIcon from "@material-ui/icons/Search";

class AddUserForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      chipArray: [],
      loading: true,
      open: false,
      severity: "",
      alertmsg: "",
      siteData: [],
      allSiteData: [],
      siteobj: { id: "", name: "" },
      siteName: "",
      disableAddSite: false,
      saveButtonDisabled: false,
    };
  }
  getSites = () => {
    fetchMethod(getAllSites, {
      // where: { name: { like: `%${this.state.siteName}%` }, active: 1 },
      where: {
        // and: [
        //   {
        //     or: [
        //       { name: { like: `%${this.state.siteName}%` } },
        //       { siteid: { like: `%${this.state.siteName}%` } },
        //     ],
        //   },
          // {
            active: 1,
          // },
        // ],
      },
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.error && res.error.statusCode === 401) {
          localStorage.clear();
          window.location = "/";
        }
        let siteDetail=res.data.allSites
        ? res.data.allSites.Sites.map((item) => {
            item.name = `${item.siteid}, ${item.name}`
            // console.log(item);
            
            return item
          })
        : [];
        this.setState({
          siteData: siteDetail,
          allSiteData:siteDetail
        });
      })
      .catch((e) => {
        console.log(e);
      });
  };
  Users = () => {
    this.props.history.push("/users");
  };
  handleTextField = (e) => {
    const {
      target: { name, value },
    } = e;
    this.setState({ [name]: value });
  };
  handleSelect = (e, value) => {
    let siteobj = value;
    let {siteData,allSiteData}=this.state
    if (siteobj) {
      if (siteobj.id) {
        siteData=allSiteData.filter(items=>items.id===siteobj.id)
        this.setState(
          { siteName: value.name, siteobj, errorSiteMessage: "" },
          () =>
            this.state.siteName.length >= 2
              ? this.setState({siteData})
              : this.setState({ siteData: [] })
        );
      } else {
        var PATTERN = RegExp(value?value:'','i');
        let filteredList = allSiteData.filter(items=>PATTERN.test(items.name));
        this.setState(
          {
            siteName: value,
            siteobj: {
              name: value,
              id: 0,
            },
            errorSiteMessage: "",
          },
          () =>
            this.state.siteName.length >= 2
              ? this.setState({ siteData: filteredList})
              : this.getSites()
        );
      }
    } else {
      this.setState({
        siteName: "",
        siteobj: {
          name: "",
          id: 0,
        },
      });
    }
  };
  buttonClicked = async (e) => {
    this.setState({ disableAddSite: true });
    let { siteName, chipArray, siteobj } = this.state;
    if (siteName !== undefined && siteName !== null && siteName !== "") {
      if (siteobj.id) {
        if (chipArray !== undefined && chipArray.length) {
          if (chipArray.filter((item) => item.id === siteobj.id).length === 0)
            chipArray.push({
              name: siteobj.name,
              label: siteobj.name,
              id: siteobj.id,
              active: 0,
            });
        } else {
          chipArray = [
            {
              name: siteobj.name,
              label: siteobj.name,
              id: siteobj.id,
              active: 0,
            },
          ];
        }
        siteName = "";
        siteobj = { id: "", name: "" };
      } else {
        // let variable = {
        //   name: siteName,
        //   active: 1,
        // };
      }
      this.setState({ siteobj, disableAddSite: false });
    }
    this.setState({ chipArray, siteName });
  };
  handleChipDelete = async (index, e) => {
    let { chipArray } = this.state;
    let options = chipArray;
    let removeSiteObj = options[index];
    if (removeSiteObj.id && removeSiteObj.active === 0) {
      options = options.filter((items, ind) => ind !== index);
      chipArray = options;
      this.setState({ chipArray });
    }
  };
  keyPress = (e) => {
    if (e.keyCode === 13) {
      this.setState({ disableAddSite: true });
      // if(this.state.siteobj.id)
      this.debounceTimer = debounce(
        this.debounceTimer,
        () => this.buttonClicked(e),
        100
      );
      // this.buttonClicked(e);
    }
  };
  SitesSection = () => {
    return (
      <React.Fragment>
        <div className="chipSection">
          {this.state.chipArray
            ? this.state.chipArray.map((chipitem, index) => {
                return (
                  // <li key={index}>
                  <Chip
                    label={chipitem.label}
                    onDelete={(e) => this.handleChipDelete(index, e)}
                    key={index}
                  />
                  // </li>
                );
              })
            : ""}
        </div>
        <div className="siteSections">
          <div>
            <Autocomplete
              // freeSolo
              id="siteName"
              options={this.state.siteData}
              getOptionLabel={(option) => (option ? option.name : "")}
              style={{ width: "100%" }}
              value={this.state.siteobj}
              required={true}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Site Name"
                  // onChange={this.handleTextField}
                  margin="normal"
                  // onKeyDown={this.keyPress}
                  required={true}
                  value={this.state.siteName}
                  name={"siteName"}
                  InputProps={{
                    ...params.InputProps,
                    className: "searchsiteicon",
                    autoComplete: "samlpetexttodisable",
                    endAdornment: <SearchIcon />,
                  }}
                ></TextField>
              )}
              onChange={this.handleSelect}
              onInputChange={this.handleSelect}
              onKeyDown={this.keyPress}
            />
            {this.state.errorSiteMessage ? (
              <FormHelperText>{this.state.errorSiteMessage}</FormHelperText>
            ) : (
              ""
            )}
          </div>
          <div>
            <Button
              onClick={this.buttonClicked}
              disabled={this.state.disableAddSite}
            >
              <AddIcon />
              Add Site
            </Button>
          </div>
        </div>
      </React.Fragment>
    );
  };
  siteArrayValidation = () => {
    if (this.state.chipArray.length) {
      return false;
    } else {
      this.setState({
        errorSiteMessage: "Site is mandatory.",
      });
      return true;
    }
  };
  preSubmitChanges = (e) => {
    this.setState({ loading: true, saveButtonDisabled: true });
    e.active = 1;
    e.sendwelcomeemail = e.sendwelcomeemail ? 1 : 0;
    mutationQueries(saveUserdata, { obj: e })
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.saveUserdata) {
          this.userSiteMap(res.data.saveUserdata.id, e.role !== "ADMIN");
          this.setState(
            {
              open: true,
              severity: "success",
              alertmsg: "User Added Successfully!",
            },
            () => {
              setTimeout(() => {
                this.props.history.push("/users");
              }, 2000);
            }
          );
        }
        if (res.error && res.error.statusCode === 401) {
          localStorage.clear();
          window.location = "/";
        }
        if (res.errors) {
          this.setState({
            open: true,
            severity: "error",
            alertmsg: res.errors.length ? res.errors[0].message : "",
            saveButtonDisabled: false,
          });
        }
      })
      .catch((e) => {
        this.setState({ loading: false, saveButtonDisabled: false });
        this.setState({
          open: true,
          severity: "error",
          alertmsg: e.message.toString().split(":")[2].replace(/"/g, ""),
        });
        console.log(e);
      });
    return true;
  };
  userSiteMap = (userid, isRole) => {
    let { chipArray } = this.state;
    let query = "";
    if (chipArray && chipArray.length && isRole)
      chipArray.map((item, index) => {
        return (query += `id${index}: saveUsersitemap(
              obj: {
                active:1,
                siteid:${item.id},
               userid:${userid}
              }
            ){id}`);
      });
    if (query !== "") {
      mutationQueries(gql`mutation{${query}}`)
        .then((res) => {})
        .catch((e) => {
          this.setState({
            open: true,
            severity: "error",
            alertmsg: e.message,
            loading: false,
          });
          console.log(e);
        });
    }
  };
  handleSnackBarClose = () => {
    let { severity } = this.state;
    this.setState({ open: false, severity: "", alertmsg: "" });
    if (severity === "success") this.props.history.push("/users");
  };
  componentDidMount() {
    let { fields } = addUser;
    let updatedFields = fields.filter((items) => items.label === "Sites").length
      ? fields
      : fields.push({ type: "heading", label: "Sites" });
    updatedFields = fields.filter((items) => items.name === "SitesName").length
      ? fields
      : fields.push({
          type: "content",
          name: "SitesName",
          required: true,
        });
    addUser.fields = fields;
    this.getSites()
    this.setState({ loading: false });
  }
  render() {
    let { fields } = addUser;
    let obj = fields.filter((items) => items.name === "sendwelcomeemail");
    obj = obj[0];
    obj.type = "checkbox";
    fields = fields.map((items) =>
      items.name === "sendwelcomeemail" ? obj : items
    );
    return (
      <div className="addUserSection">
        {this.state.loading ? (
          <div className="Loader">
            <FadeLoader
              style={{ height: "15", width: "5", radius: "2" }}
              color={"#6FABF0"}
              loading={this.state.loading}
            />
          </div>
        ) : (
          ""
        )}
        {this.state.open ? (
          <SnackBarComponent
            severity={this.state.severity}
            open={this.state.open}
            alertmsg={this.state.alertmsg}
            handleClose={this.handleSnackBarClose}
            className="addUserSnackBar"
          />
        ) : (
          ""
        )}
        <ul className="sitepath">
          <li onClick={this.Users} style={{ cursor: "pointer" }}>
            Users
          </li>
          <li>
            <span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="13.992"
                height="8"
                viewBox="0 0 13.992 8"
              >
                <defs></defs>
                <path
                  className="a"
                  d="M13.186,16.835l5.291-5.295a1,1,0,0,1,1.412,0,1.008,1.008,0,0,1,0,1.416l-5.995,6a1,1,0,0,1-1.379.029L6.479,12.961a1,1,0,0,1,1.412-1.416Z"
                  transform="translate(-6.188 -11.246)"
                />
              </svg>
            </span>
          </li>
          <li> Add User</li>
        </ul>
        <h3>Add User</h3>
        <FormComponent
          formConfig={addUser}
          showContentOnForm={{ SitesName: this.SitesSection }}
          query={saveUserdata}
          preSubmitChanges={this.preSubmitChanges}
          saveButtonDisabled={this.state.saveButtonDisabled}
          contentValidationOnForm={{ SitesName: this.siteArrayValidation }}
        />
      </div>
    );
  }
}

export default AddUserForm;
